import { render, staticRenderFns } from "./WordWithPopover.vue.js?vue&type=template&id=1d6ce0d2!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./WordWithPopover.vue?vue&type=template&id=1d6ce0d2"
import script from "./WordWithPopover.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./WordWithPopover.vue?vue&type=script&lang=js"
export * from "./WordWithPopover.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./WordWithPopover.vue?vue&type=script&lang=js"
import style0 from "./WordWithPopover.vue.scss?vue&type=style&index=0&id=1d6ce0d2&prod&lang=scss!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./WordWithPopover.vue?vue&type=style&index=0&id=1d6ce0d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports